import {SketchLineRelationConstraint} from './SketchLineRelationConstraint';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';

let count = 0;


/**
 * 线-固定关系约束。
 */
export function isLineFixConstraint(value: object): value is LineFixConstraint {
    return Reflect.get(value, "isLineFixConstraint") === true;
}
export class LineFixConstraint extends SketchLineRelationConstraint<any> {
    readonly isLineFixConstraint: boolean = true;
    /**
     * 关系类型。
     */
    public relationType = SketchRelationKind.Fix;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    public get baseDisplayName(): string {
        return '固定';
    }

}


